import React from 'react';

import {SetPasswordForm} from '@features/Password/SetPassword';

export const SetPasswordPage = () => <SetPasswordForm />;
